import { render, staticRenderFns } from "./WhatsAppMessageEditor.vue?vue&type=template&id=b7b8b1d6&scoped=true"
import script from "./WhatsAppMessageEditor.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppMessageEditor.vue?vue&type=style&index=0&id=b7b8b1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b8b1d6",
  null
  
)

export default component.exports